import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { Box, IconButton, InputAdornment, Typography } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import dayjs from "dayjs";

const CustomDatePickerInput = ({
  style,
  InputProps,
  value,
  onChange,
  placeholder = "Date",
  ...props
}) => {
  const dayjsValue = value ? dayjs(value) : null;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        value={dayjsValue}
        format="DD/MM/YYYY"
        onChange={onChange}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            height: "35px",

            "@media(max-width: 600px)": {
              fontSize: "12px",
            },
            boxShadow: "0.9375px 0.9375px 2.8125px 0px #00000026",
            backgroundColor: "#FCFAFA",
            "&:hover fieldset": {
              border: "0.1px solid #fff",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
            ...style,
          },
        }}
        InputProps={{
          ...InputProps,
          placeholder: placeholder,
          endIcon: <CalendarTodayIcon />,
        }}
        defaultHighlight="From"
        {...props}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePickerInput;
